import React from "react";

function Preloader({ loading }) {
  return (
    <div className={`preloader ${loading ? "" : "fade-out"}`}>
      <div className="spinner"></div>
    </div>
  );
}

export default Preloader;
